import ajax from '../../helpers/ajax'

function messageDetailUrl(threadId, messageId) {
  return `${messageListUrl(threadId)}/${messageId}`
}

function messageFlagsUrl(threadId, messageId) {
  return `${messageDetailUrl(threadId, messageId)}/flags`
}

function messageRestoreUrl(threadId, messageId) {
  return `${messageDetailUrl(threadId, messageId)}/restore`
}

function messageListUrl(threadId) {
  return `/forum_threads/${threadId}/messages`
}

function threadDetailUrl(threadId) {
  return `/forum_threads/${threadId}`
}

const ForumsService = {
  getThreads({url, page}) {
    return new Promise((resolve, reject) => {
      ajax.get({
        url,
        params: { page },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  getThread({url}) {
    return new Promise((resolve, reject) => {
      ajax.get({
        url,
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  createThread(url, {title, messageAttributes}) {
    return new Promise((resolve, reject) => {
      ajax.post({
        url: url,
        data: {
          thread: {
            title,
            messages_attributes: [messageAttributes]
          }
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  createReply(threadId, content) {
    return new Promise((resolve, reject) => {
      ajax.post({
        url: messageListUrl(threadId),
        data: {
          forum_message: { content }
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  deleteMessage(threadId, messageId) {
    return new Promise((resolve, reject) => {
      ajax.delete({
        url: messageDetailUrl(threadId, messageId),
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  restoreMessage(threadId, messageId) {
    return new Promise((resolve, reject) => {
      ajax.put({
        url: messageRestoreUrl(threadId, messageId),
        data: {
          forum_message: { is_deleted: false }
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  flagMessage(threadId, messageId, reason) {
    return new Promise((resolve, reject) => {
      ajax.post({
        url: messageFlagsUrl(threadId, messageId),
        data: {
          flag: { reason }
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  updateMessage(threadId, messageId, newContent) {
    return new Promise((resolve, reject) => {
      ajax.put({
        url: messageDetailUrl(threadId, messageId),
        data: {
          forum_message: { content: newContent }
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  },
  updateThread(threadId, newTitle, newContent) {
    return new Promise((resolve, reject) => {
      ajax.put({
        url: threadDetailUrl(threadId),
        data: {
          thread: { title: newTitle },
          forum_message: { content: newContent }
        },
        successHandler: (response) => {
          resolve(response)
        },
        errorHandler: (err) => {
          reject(err)
        }
      })
    })
  }
}

export default ForumsService
